module.exports = __webpack_public_path__ + "static/media/sc_5_i.126ff501.png";